module.exports = __webpack_public_path__ + "img/auth_bg.ae29ea2f.jpg";